import React from "react"
import Autosuggest from 'react-autosuggest'
import Ajax from "superagent"
import {throttle} from 'lodash'
import { MapPin } from "react-feather"
import {MediaBoxBody, MediaBoxTitle, MediaBoxDescription} from "react-weui"

import {randstr} from '../../../../lib/Tools'
import theme from './AddressInputTheme.css'

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.description;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div
    style={{
      display: "flex", 
      flexShrink: 0,
      alignItems: "center",
      backgroundColor: "white",
    }}
  > 
    <div style={{marginRight: "5px"}}>
      <MapPin size="4vh" color="#1AAD19" />
    </div>
    <MediaBoxBody>
      <MediaBoxTitle>{suggestion.structured_formatting.main_text}</MediaBoxTitle>
      <MediaBoxDescription>
        {suggestion.structured_formatting.secondary_text}
      </MediaBoxDescription>
    </MediaBoxBody>
  </div>
)

export default class GoogleInput extends React.Component {
  constructor(props) {
    super(props)
    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      suggestions: [],
      id: randstr(),
      readOnly: true
    }
    this.throttlePlacesFetch = throttle((input) => {
      this.getPlaces(input)
    }, 500)
  }

  onChange(event, { newValue, method }) {
    this.props.changeAddress(newValue, method)
  }

  onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
    this.props.changeCoords(suggestion.geoLocation, suggestion.city)
    this.setState({readOnly: true})
  }

  getPlaces(input) {
    Ajax
      .post(`/directionsapi/getdirections`)
      .send({input, city: this.props.city})
      .then(res => {
        this.setState({
          suggestions: res.body
        })
      })
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested({ value }) {
    this.throttlePlacesFetch(value)
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested() {
    this.setState({
      suggestions: []
    })
  }

  render() {
    const { suggestions } = this.state;
    const {value} = this.props
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder,
      value,
      onChange: (event, newValue) => this.onChange(event, newValue),
      id: this.state.id,
    };

    // Finally, render it!
    return (
      <Autosuggest
        id={this.state.id}
        theme={theme}
        suggestions={suggestions}
        onSuggestionsFetchRequested={vl => this.onSuggestionsFetchRequested(vl)}
        onSuggestionsClearRequested={() => this.onSuggestionsClearRequested()}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={(x, y) => this.onSuggestionSelected(x, y)}
        inputProps={inputProps}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/AddressInput.jsx